import { Col, Row } from "reactstrap";

import FieldFormatter from "../Records/Formatters/FieldFormatter";
import useFieldMap from "../../hooks/useFieldMap";
import FieldUtils from "utils/FieldUtils";
import useModule from "hooks/useModule";

const TableListItemInfo = ({
  item,
  subitemParentID,
  moduleAPIName,
  multiSubitemFieldAPIName,
  separateName,
  fields,
  reusableViews,
}) => {
  const { getModule } = useModule();
  const fieldMap = useFieldMap(
    moduleAPIName,
    null,
    false,
    multiSubitemFieldAPIName
  );
  const fieldNameMap = useFieldMap(
    moduleAPIName,
    "Name",
    separateName,
    multiSubitemFieldAPIName
  );

  const getLookUp = (fieldAPIName, item) => {
    const lookUpReference = fieldAPIName.split(".")[0];
    const lookUpField = fieldAPIName.split(".")[1];

    if (
      !lookUpReference ||
      !lookUpField ||
      item?.SubitemParent ||
      (!item?.[lookUpReference]?.hasOwnProperty(lookUpField) &&
        item?.[lookUpReference] !== null)
    ) {
      return null;
    }

    return {
      ID: item[lookUpReference]?.id || "No ID",
      ModuleAPIName: item[lookUpReference]?._ModuleAPIName || "No APIName",
    };
  };

  return (
    <>
      {fields?.map((fieldAPIName) => {
        const isLookUp = fieldAPIName.split(".")[1] ? true : false;
        const lookUpValue = isLookUp
          ? getLookUp(fieldAPIName, item)
          : undefined;
        const lookUpField = isLookUp ? fieldAPIName.split(".")[1] : undefined;
        const lookUpReference = isLookUp
          ? fieldAPIName.split(".")[0]
          : undefined;
        const formattedLookUpField = `${lookUpReference} - ${lookUpField}`;
        const lookUpModule = isLookUp
          ? getModule(lookUpValue.ModuleAPIName)
          : undefined;

        const field = isLookUp
          ? FieldUtils.getFieldFromModule(lookUpModule, lookUpField)
          : fieldMap[fieldAPIName];

        const value = isLookUp
          ? item?.[lookUpReference]?.[lookUpField]
          : item?.[field?.APIName];

        if (!field) return null;

        return (
          <Row
            className="d-flex justify-content-between align-items-center m-0 p-0 mt-3 text-dark"
            key={fieldAPIName}
          >
            <Col xs={5} className="pl-2 pr-0">
              <div
                className="text-uppercase"
                style={{ fontWeight: 600, fontSize: "12px" }}
              >
                {isLookUp ? formattedLookUpField : field.Name}
              </div>
            </Col>
            <Col
              xs={7}
              style={{
                fontSize: "12px",
              }}
              align="right"
              className="p-0"
            >
              <FieldFormatter
                field={field}
                value={value}
                record={item}
                recordID={item.id || item._id}
                moduleAPIName={item._ModuleAPIName}
                table={true}
                subitemParentID={subitemParentID}
                multiSubitemID={subitemParentID ? item?.id : null}
                lookUpID={lookUpValue?.ID}
                lookUpModuleAPIName={lookUpValue?.ModuleAPIName}
                lookUpField={lookUpReference}
                reusableViews={reusableViews?.ReferenceFields ?? {}}
              />
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default TableListItemInfo;
